import { ArrowDown, Check } from '@tamagui/lucide-icons-2'
import Button from 'components/button'
import { SizableText, View, YStack } from 'tamagui'
import { useOnboarding } from '../OnboardingContext'

const FlowStep = ({
    number,
    text,
    isLast,
}: {
    number: number
    text: string
    isLast?: boolean
}) => (
    <YStack alignItems="center" gap="$1">
        <View
            width={28}
            height={28}
            borderRadius={999}
            backgroundColor="$accentSoft"
            alignItems="center"
            justifyContent="center"
        >
            <SizableText size="$2" fontWeight="700" color="$accentText">
                {number}
            </SizableText>
        </View>
        <SizableText size="$2" color="$colorSoft" textAlign="center">
            {text}
        </SizableText>
        {!isLast && <ArrowDown size={14} color="$colorFaint" />}
    </YStack>
)

export default function InvoiceGuide() {
    const { completeOnboarding } = useOnboarding()

    return (
        <YStack gap="$4">
            <SizableText size="$6" fontWeight="700">
                How Invoicing Works
            </SizableText>
            <SizableText size="$3" color="$colorSoft">
                BuyerFlo automatically creates Xero invoices at key milestones.
            </SizableText>

            {/* Engagement Invoice */}
            <YStack
                gap="$2"
                padding="$3"
                backgroundColor="$accentSoft"
                borderRadius={14}
                borderWidth={1}
                borderColor="$borderColor"
            >
                <SizableText size="$4" fontWeight="700" color="$accentText">
                    Engagement Invoice
                </SizableText>
                <YStack gap="$1" paddingTop="$2">
                    <FlowStep number={1} text="Client signs the Form 6 (Agent Appointment)" />
                    <FlowStep number={2} text="Engagement invoice auto-created in Xero" />
                    <FlowStep number={3} text="Invoice sent to client's email" />
                    <FlowStep number={4} text="Payment tracked on the client record" isLast />
                </YStack>
            </YStack>

            {/* Commission Invoice */}
            <YStack
                gap="$2"
                padding="$3"
                backgroundColor="$statusOkSoft"
                borderRadius={14}
                borderWidth={1}
                borderColor="$borderColor"
            >
                <SizableText size="$4" fontWeight="700" color="$statusOk">
                    Commission Invoice
                </SizableText>
                <YStack gap="$1" paddingTop="$2">
                    <FlowStep number={1} text="Property goes unconditional" />
                    <FlowStep number={2} text="Set the unconditional date on the client record" />
                    <FlowStep number={3} text="Commission invoice auto-created in Xero" />
                    <FlowStep number={4} text="Invoice sent to buyer via Xero" isLast />
                </YStack>
            </YStack>

            <SizableText size="$2" color="$colorMuted">
                You can configure a delay for engagement invoices and choose which Xero items to use in your Xero settings.
            </SizableText>

            <Button
                size="$4"
                theme="primary"
                onPress={completeOnboarding}
                icon={<Check size={16} />}
            >
                Finish setup
            </Button>
        </YStack>
    )
}
